import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'products/nomad_insurance/components/Button';
import PropTypes from 'prop-types';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import { PLANS } from 'products/nomad_insurance/constants';
import { ButtonsWrapper } from './styled';

const UpdateUSAddonModal = ({ onClose, isOpen, addonChange }) => {
  const ADDONS = Object.values(PLANS);
  const { addons } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const USCoverageAddon = ADDONS.find((addon) => addon.value === 'USA_COVERAGE');
  const hasUSCoverage = addons.find((addon) => addon.id === USCoverageAddon.id);

  const onYes = () => {
    addonChange(USCoverageAddon);
    onClose();
  };

  return (
    <BaseModal
      heading={hasUSCoverage ? 'Remove US coverage?' : 'Add-on required for US coverage'}
      isOpen={isOpen}
      onClose={onClose}
    >
      {hasUSCoverage
        ? 'If you remove the United States, Guam, Virgin Islands (US), Northern Mariana Islands and/or American Samoa as a destination, you will not be covered while traveling there. Would you like to remove the add-on for US travel?'
        : 'You cannot select United States, Guam, Virgin Islands (US), Northern Mariana Islands and/or American Samoa as a destination unless you buy the US coverage add-on. Would you like to add the US as a destination for an additional cost?'}

      <ButtonsWrapper>
        <Button onClick={onClose} variant="textOnly">
          Never mind
        </Button>
        <Button onClick={onYes} color="pickledBluewood">
          {hasUSCoverage ? 'Remove US coverage' : 'Add US coverage'}
        </Button>
      </ButtonsWrapper>
    </BaseModal>
  );
};

UpdateUSAddonModal.propTypes = {
  addonChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool
};

export default UpdateUSAddonModal;
